import React from 'react';
import { cn } from '../../utils/cn';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  elevated?: boolean;
  interactive?: boolean;
  style?: React.CSSProperties;
}

const Card: React.FC<CardProps> = ({ children, className, hover = false, elevated = false, interactive = false, style }) => {
  return (
    <div
      className={cn(
        'bg-white rounded-2xl shadow-sm border border-slate-100 p-6 transition-all duration-300',
        hover && 'hover:shadow-lg',
        elevated && 'shadow-lg hover:shadow-2xl border-0 p-8',
        interactive && 'shadow-md hover:shadow-xl transform hover:-translate-y-1',
        className
      )}
      style={style}
    >
      {children}
    </div>
  );
};

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ children, className }) => {
  return (
    <div className={cn('mb-4', className)}>
      {children}
    </div>
  );
};

interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const CardTitle: React.FC<CardTitleProps> = ({ children, className }) => {
  return (
    <h3 className={cn('text-lg font-semibold text-slate-900', className)}>
      {children}
    </h3>
  );
};

interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}

export const CardContent: React.FC<CardContentProps> = ({ children, className }) => {
  return (
    <div className={cn('text-slate-600', className)}>
      {children}
    </div>
  );
};

interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}

export const CardFooter: React.FC<CardFooterProps> = ({ children, className }) => {
  return (
    <div className={cn('mt-4 pt-4 border-t border-slate-200', className)}>
      {children}
    </div>
  );
};

export default Card;
